import { Checkbox, styled } from "@mui/material";

const CheckboxCustom = styled(Checkbox)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
  "&.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
    fill: theme.palette.primary.main,
  },
  "&.MuiCheckbox-root.MuiCheckbox-colorError": {
    color: theme.palette.error.main,
  },
}));

export default CheckboxCustom;
